import React from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";
import "../../../../assets/css/chat/chat-header.css";

import { useDispatch } from "react-redux";
import {
  responsiveUI,
  responsiveUI_userList,
  responsiveUI_chatArea,
} from "../../../../store/slices/chatUi";



const ChatAreaHeader = ({ orderTrackingId, username, profileImage }) => {
  const dispatch = useDispatch();

  let viewportWidth = window.innerWidth || document.documentElement.clientWidth;

  const viewDtails_withResponsiveUI = () => {
    dispatch(responsiveUI(true));
  };

  const mobile_list_hide_action = () => {
    dispatch(responsiveUI_userList(true));
    dispatch(responsiveUI_chatArea(false));
  };

  return (
    <div className="chat-area-header">
      <Box className="d-flex" onClick={viewDtails_withResponsiveUI}>

        <Avatar
          alt={username}
          src={profileImage}
          className="header-avatar"
        />
        
        <h1>{orderTrackingId ? `#Order-${orderTrackingId}` : username}</h1>
      </Box>

      {viewportWidth <= 720 && (
        <Button
          className="chat-area-back-btn"
          onClick={mobile_list_hide_action}
        >
          <ArrowBackIcon />
        </Button>
      )}
    </div>
  );
};

export default ChatAreaHeader;
